import EventEmitter from "./utils/EventEmitter";
import Menu from "./Menu";
import SelectLocale from "./form/SelectLocale";
import TextEllipsis from "./TextEllipsis";

import HomePage from "./HomePage";
import TaxonomyPage from "./TaxonomyPage";
import AgendaPage from "./AgendaPage";
import ViewFiltersForm from "./form/ViewFiltersForm";
import ShortcutLinksPage from "./ShortcutLinksPage";
import LazyImages from "./utils/LazyImages";
import MultipleViewsCustomTabs from "./MultipleViewsCustomTabs";
import Sliders from "./Sliders";
import WysiwygSanitizer from "./utils/WysiwygSanitizer";
import AccordionsPushes from "./AccordionsPushes";
import CustomPager from "./CustomPager";
import TableOfContent from "./TableOfContent";
import ShareButtons from "./ShareButtons";
import Tooltip from "./Tooltip";
import ContentAvailableLanguages from "./ContentAvailableLanguages";
import Headers from "./Headers";
import AnalysesStickyBar from "./AnalysesStickyBar";
import DynamicDrupalView from "./DynamicDrupalView";
import ListNameAuthorsOverflow from "./utils/ListNameAuthorsOverflow";
import MenuMobile from "./MenuMobile";
import ListInterventionsMediatiquesPage from "./ListInterventionsMediatiquesPage";
import Newsroom from "./Newsroom";
import SearchPage from "./SearchPage";
import UserInterface from "./UserInterface";
import PageEvent from "./PageEvent";

export default class Main extends EventEmitter {
    constructor() {
        super()

        this.lazyImages = new LazyImages()
        this.listNameAuthorsOverflow = new ListNameAuthorsOverflow()

        this.wysiwygSanitizer = new WysiwygSanitizer()

        // Pages
        this.homePage = document.querySelector('.page-node-type-page-d-accueil')
        this.shortcutLinksPages = document.querySelectorAll('.shortcut-links-page')
        this.taxonomyPage = document.querySelector('.taxonomy-page')
        this.pageAgenda = document.querySelector('.page-agenda')
        this.listInterventionsMediatiquesPage = document.querySelector('.liste-des-interventions-mediatiques-page')
        this.newsroomPage = document.querySelector('.page-node-type-newsroom')
        this.searchPage = document.querySelector('.search-page')
        this.userPage = document.querySelector('.user-interface')
        this.pageEvent = document.querySelector('.page-node-type-evenements')

        // Components UI
        this.ellipsisBlocs = document.querySelectorAll('.ellipsis-bloc')
        this.selectLocale = document.querySelectorAll('.t-select-locale')
        this.sanitizeFiles = document.querySelectorAll('.sanitize-file')
        this.howToQuoteModal = document.querySelector('.how-to-quote-modal')
        this.howToQuoteButton = document.querySelector('.how-to-quote-button')

        // Forms
        this.viewFiltersForm = document.querySelectorAll('.view-filters')

        // Custom components
        this.menu = document.querySelector('header.main-header')
        this.menuMobile = document.querySelector('header.main-header--mobile')
        this.cleanHeader = document.querySelector('.clean-header')
        this.multipleViewsCustomTabs = document.querySelectorAll('.multiple-views-custom-tabs')
        this.accordionsPushes = document.querySelectorAll('.accordions-pushes')
        this.customPager = document.querySelectorAll('.custom-pager')
        this.tableOfContents = document.querySelectorAll('.table-of-content')
        this.shareButtons = document.querySelectorAll('.share-buttons')
        this.copyableContents = document.querySelectorAll('.copyable-content')
        this.contentAvailableLanguages = document.querySelectorAll('.content-available-languages')
        this.analysesStickyBar = document.querySelector('.analyse-sticky-bar')
        this.dynamicViews = document.querySelectorAll('.dynamic-view')
        this.urlInject = document.querySelectorAll('.url-inject')
        this.columner = document.querySelector('.dynamic-columner')
        this.paragraphAnalyseContent = document.querySelector('.paragraph-analyse-content')

        this.initComponents()
    }

    initComponents() {
        if (this.menu) {
            new Menu(this.menu)
        }
        if (this.menuMobile) {
            new MenuMobile(this.menuMobile)
        }

        if (this.cleanHeader) {
            new Headers(this.cleanHeader)
        }

        if (this.homePage) {
            new HomePage(this.homePage)
        }

        if (this.pageEvent) {
            new PageEvent(this.pageEvent)
        }

        if (this.taxonomyPage) {
            new TaxonomyPage(this.taxonomyPage)
        }

        if (this.pageAgenda) {
            this.agendaPageInstance = new AgendaPage(this.pageAgenda)
        }

        if (this.newsroomPage) {
            new Newsroom(this.newsroomPage)
        }

        if (this.listInterventionsMediatiquesPage) {
            new ListInterventionsMediatiquesPage(this.listInterventionsMediatiquesPage)
        }

        if (this.searchPage) {
            this.searchPageInstance = new SearchPage(this.searchPage)
        }

        if (this.userPage) {
            this.userInterface = new UserInterface()
        }

        const sliders = new Sliders()
        sliders.on('slideChangeTransitionEnd', () => {
            this.lazyImages.checkImages()
        })

        this.shortcutLinksPages.forEach((el) => {
            new ShortcutLinksPage(el)
        })

        this.ellipsisBlocs.forEach((bloc) => {
            new TextEllipsis(bloc)
        })

        this.selectLocale.forEach((el) => {
            new SelectLocale(el)
        })

        this.customPager.forEach((el) => {
            new CustomPager(el)
        })

        this.tableOfContents.forEach((el) => {
            new TableOfContent(el)
        })

        this.shareButtons.forEach((el) => {
            new ShareButtons(el)
        })

        this.contentAvailableLanguages.forEach((el) => {
            new ContentAvailableLanguages(el)
        })

        this.dynamicViews.forEach((el) => {
            new DynamicDrupalView(el)
        })

        this.copyableContents.forEach((el) => {
            el.addEventListener('click', () => {
                const range = document.createRange();
                range.selectNode(el);
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
                document.execCommand("copy");
                window.getSelection().removeAllRanges();
            })
        })

        if (this.paragraphAnalyseContent && window.innerWidth > 769) {

            this.paragraphAnalyseContent.querySelectorAll('.full-width-paragraph').forEach((el) => {
                const w = this.paragraphAnalyseContent.getBoundingClientRect().width
                el.style.width = `${w - 80}px`
            })

            window.addEventListener('resize', () => {
                this.paragraphAnalyseContent.querySelectorAll('.full-width-paragraph').forEach((el) => {
                    const w = this.paragraphAnalyseContent.getBoundingClientRect().width
                    el.style.width = `${w - 80}px`
                })
            })
        }

        /*this.fileDownload.forEach((el) => {
            const downloadLink = el.querySelector('a')
            downloadLink.setAttribute('download', '')
            downloadLink.innerText = `.${downloadLink.getAttribute('href').split('/').pop().split('.').pop()}`

            el.addEventListener('click', () => {
                downloadLink.click()
            })
        })

        this.fileNames.forEach((el) => {
            // on recup le nom du fichier, on veut tronquer le text si il est trop long de 25 caractères mais on garde l'éxtension
            const filename = el.innerText
            const extension = filename.split('.').pop()
            const name = filename.split('.').slice(0, -1).join('.')
            const truncatedName = name.substring(0, 25)
            el.innerText = `${truncatedName}[...].${extension}`
        })*/

        this.sanitizeFiles.forEach((el) => {
            const filesize = el.querySelector('.filesize')
            filesize.innerText = `${Math.round(parseInt(filesize.innerText) / 1024)} Ko`

            const filename = el.querySelector('.filename')
            filename.innerText = filename.innerText.split('/').pop()

        })

        this.urlInject.forEach((el) => {
            const url = el.querySelector('h5 a').getAttribute('href')
            const a = el.querySelector('h5 + a')
            a.setAttribute('href', url)
        })


        // FORMS
        this.viewFiltersFromInstance = []
        this.viewFiltersForm.forEach((el) => {
            let v = new ViewFiltersForm(el)
            this.viewFiltersFromInstance.push(v)
        })

        this.multipleViewsCustomTabs.forEach((el) => {
            const m = new MultipleViewsCustomTabs(el)
            m.on('viewLoaded', () => {
                this.listNameAuthorsOverflow.update()
                this.wysiwygSanitizer.sanitize()
            })
        })

        this.accordionsPushes.forEach((el) => {
            new AccordionsPushes(el)
        })

        if (this.analysesStickyBar) {
            new AnalysesStickyBar(this.analysesStickyBar)
        }

        if (this.columner) {
            // get first paragraph
            const firstParagraph = this.columner.querySelector('p')
            // Count number of words
            const words = firstParagraph.innerText.split(' ').length

            // If there are more than 200 words, we add a class to the columner
            if (words > 50) {
                this.columner.classList.add('t-columns-2')
            }
        }

        if (this.howToQuoteButton && this.howToQuoteModal) {
            const authors = document.querySelectorAll('.authors-list-hidden-data .author')
            const copyBtn = this.howToQuoteModal.querySelector('.copy-btn')

            let message = copyBtn.dataset.text

            let data = []

            if (authors.length === 0) {
                this.howToQuoteModal.querySelector('.by-author').remove()
            }

            authors.forEach(author => {
                if (author.classList.contains('author-int')) {

                    const authorData = {
                        label: author.dataset.label
                    }
                    data.push(authorData)
                }
                if (author.classList.contains('author-ext')) {
                    const authorData = {
                        label: author.dataset.label,
                    }
                    data.push(authorData)
                }
            })

            const authorsList = this.howToQuoteModal.querySelector('.authors-list')
            data.forEach(author => {
                const authorEl = document.createElement('span')
                authorEl.innerText = author.label
                authorsList.appendChild(authorEl)
            })

            // Mettre une virgule entre chaque auteur et en faire une chaine de caractère
            const authorsListComma = Array.from(authorsList.children).map((el) => el.innerText).join(', ')

            message = message.replace('AUTHORS', authorsListComma)
            copyBtn.dataset.text = message

            this.howToQuoteButton.addEventListener('click', (event) => {
                event.preventDefault()
                this.howToQuoteModal.classList.add('is-active')
            })
            this.howToQuoteModal.querySelector('.close-modal').addEventListener('click', (event) => {
                event.preventDefault()
                this.howToQuoteModal.classList.remove('is-active')
            })

            this.howToQuoteModal.querySelector('.copy-btn').addEventListener('click', (event) => {
                const text = copyBtn.dataset.text
                navigator.clipboard.writeText(text).then(() => {
                    event.target.innerText = copyBtn.dataset.copied
                    setTimeout(() => {
                        event.target.innerText = copyBtn.dataset.copy
                    }, 1200)
                })
            })
        }

        new Tooltip()
    }

    onAjaxComplete() {
        // We do that because we need to re-init all inputs (selects, checkboxes, etc.)
        // Because the way drupal ajax works, it refreshes the whole view dom
        this.viewFiltersFromInstance.forEach((v) => {
            v.destroy()
        })

        // destroy all viewFiltersForm instances
        this.viewFiltersForm = document.querySelectorAll('.view-filters')
        this.viewFiltersFromInstance = []
        this.viewFiltersForm.forEach((el) => {
            let v = new ViewFiltersForm(el)
            this.viewFiltersFromInstance.push(v)
        })

        this.lazyImages.updateImages()

        if (this.agendaPageInstance) {
            this.agendaPageInstance.onAjaxComplete()
        }
    }
}


(Drupal => {
    let attachedOnce = false;
    let userFavoriteBtnsOnce = false;
    let userPersonalInformationFormOnce = false;

    const mandatoryDOMElementsFound = []

    Drupal.behaviors.mainClass = {
        attach(context, settings) {

            // Sorry but Drupal is stupid ....
            // We list all the elements we need to find before instanciating the Main class
            // (Because when connected to the back office, the elements are not present in the DOM yet)
            const elmToFind = ['.t-select-locale', '.results-button']

            // We loop through the list of elements to find them in the DOM and push them in the array r
            elmToFind.forEach((el) => {
                if (context.querySelector(el) && !mandatoryDOMElementsFound.includes(el)) {
                    mandatoryDOMElementsFound.push(el)
                }
            })

            // When all the elements are found in the DOM, we instanciate the Main class
            if (mandatoryDOMElementsFound.length === elmToFind.length) {
                if (!window.ifriTheme) {
                    window.ifriTheme = new Main();
                }
            }

            if (context.querySelector('[data-drupal-messages]')) {
                const drupalMessages = context.querySelector('[data-drupal-messages]')
                drupalMessages.classList.add('show')
                const cross = context.querySelector('[data-drupal-messages] .cross')
                if (cross) {
                    cross.addEventListener('click', () => {
                        drupalMessages.classList.remove('show')
                    })
                }
            }

            if (context.querySelectorAll('.user-sub-menu').length) {
                const userMenus = context.querySelectorAll('.user-sub-menu')
                const route = window.location.pathname

                userMenus.forEach((userMenu) => {
                    const userMenuLinks = userMenu.querySelectorAll('a')

                    userMenuLinks.forEach((link) => {
                        if (route.includes('/user/') && route.includes('/edit') && link.getAttribute('href').includes('/edit')) {
                            link.classList.add('is-active')
                            link.parentElement.classList.add('is-active')
                        } else if (link.classList.contains('is-active')) {
                            link.parentElement.classList.add('is-active')
                        }
                    })
                })
            }

            if (Array.from(context.querySelectorAll('.path-user .action-unflag')).length) {
                if (!userFavoriteBtnsOnce) {
                    userFavoriteBtnsOnce = true;
                    if (window.ifriTheme) {
                        window.ifriTheme.userInterface.initFavoriteBtns()
                    }
                }
            }
        }
    }

    Drupal.behaviors.ajaxCompleteCallback = {
        attach(context, settings) {
            if (!attachedOnce) {
                attachedOnce = true;
                views_refresh(jQuery);
            }
        }
    }

    function views_refresh($){
        $(document).ajaxComplete(function() {
            if (window.ifriTheme) {
                window.ifriTheme.onAjaxComplete();
            }
        });
    }

})(Drupal, jQuery);





